/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiLiveSchedule } from './LiveSchedule';
import { ApiAvAsset } from './AvAsset';

export interface LiveStreamRequest {

    id?: string;

    title?: string;

    /**
     * Whether the stream is active
     */
    active?: boolean;

    description?: string;

    started?: string;

    finished?: string;

    /**
     * Whether the stream is premium
     */
    premium?: boolean;

    /**
     * Whether the stream is unlisted
     */
    unlisted?: boolean;

    platform_name?: string;

    live_events?: ApiLiveSchedule;

    live_event?: ApiLiveSchedule;

    active_live_event?: ApiLiveSchedule;

    /**
     * Whether the stream is available
     */
    available?: boolean;

    publish_targets?: string[];

    created_at?: string;

    updated_at?: string;

    asset?: ApiAvAsset;

    backdrop?: string;

}

@Model('LiveStream')
export class ApiLiveStream extends BaseModel implements LiveStreamRequest {

    
    
    id: string;

    
    
    title: string;

    /**
     * Whether the stream is active
     */
    
    
    active: boolean;

    
    
    description: string;

    
    
    started: string;

    
    
    finished: string;

    /**
     * Whether the stream is premium
     */
    
    
    premium: boolean;

    /**
     * Whether the stream is unlisted
     */
    
    
    unlisted: boolean;

    
    
    platform_name: string;

    @Type('ApiLiveSchedule')
    @Expand()
    live_events: ApiLiveSchedule;

    @Type('ApiLiveSchedule')
    @Expand()
    live_event: ApiLiveSchedule;

    @Type('ApiLiveSchedule')
    @Expand()
    active_live_event: ApiLiveSchedule;

    /**
     * Whether the stream is available
     */
    
    
    available: boolean;

    
    
    publish_targets: string[];

    
    
    created_at: string;

    
    
    updated_at: string;

    @Type('ApiAvAsset')
    @Expand()
    asset: ApiAvAsset;

    
    
    backdrop: string;

}
